export const FETCH_SKU_UOMS_REQUEST = '@sites/FETCH_SKU_UOMS_REQUEST';
export const FETCH_SKU_UOMS_SUCCESS = '@sites/FETCH_SKU_UOMS_SUCCESS';
export const FETCH_SKU_UOMS_FAILURE = '@sites/FETCH_SKU_UOMS_FAILURE';
